function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.65,
  stroke: "#A0AFBE",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 12v7l-4 2M5 16.056L8 19l3-2.944M17 26a9 9 0 10-9-9"
}));
function SvgHistoryGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none"
  }, props), _ref);
}
export default SvgHistoryGray;